// FileUpload.js — Upgraded with block.id and proper root cleanup
import { createRoot } from "react-dom/client";
import React, { useState, useEffect } from "react";
import PdfViewer from "../../CommonComponents/PdfViewer";

function FileUpload({ url }) {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    setLoading(true);
    // Simulate async (in real use, fetch pre-signed URL)
    setPdfUrl(url);
    setLoading(false);
  }, [url]);

  useEffect(() => {
    const handleExitFullscreen = () => {
      if (!document.fullscreenElement) setIsFullscreen(false);
    };
    document.addEventListener("fullscreenchange", handleExitFullscreen);
    return () => document.removeEventListener("fullscreenchange", handleExitFullscreen);
  }, []);

  if (loading) return <h1>Loading...</h1>;

  return (
    <div className={isFullscreen ? "pdfWrapperfullscreen" : "pdfWrapper"}>
      {loading && isFullscreen && (
        <div className="pdfWrapperfullscreen">
          <h1>Loading...</h1>
        </div>
      )}
      <PdfViewer path={url} />
    </div>
  );
}

export default class InstantPdfTool {
  constructor({ data, config, api, block }) {
    this.api = api;
    this.config = config;
    this.blockId = block?.id;
    this.data = {
      url: data?.url || "",
      file: data?.file || null,
    };
    this.CSS = { wrapper: "pdf" };
    this.nodes = { holder: null };
    this._root = null;
  }

  static get toolbox() {
    return {
      title: "Pdf",
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 18 28" fill="none">
        <path d="M10.75 0.875H0.25V27.125H17.75V7.875L10.75 0.875ZM16.875 26.25H1.125V1.75H9.875V8.75H16.875V26.25Z" fill="#373739" fill-opacity="0.7"/>
      </svg>`,
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  render() {
    this.wrapper = document.createElement("div");
    this.wrapper.classList.add("instant-pdf-tool");
    if (!this.data.url && !this.data.file) {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.title = "Click to upload PDF";
      fileInput.addEventListener("change", () =>
        this.handleImageSelection(fileInput.files[0])
      );
      this.wrapper.appendChild(fileInput);
    }
    else if (this.data.file instanceof File) {
      const url = URL.createObjectURL(this.data.file);
      this.displayPdf(null, url);
    }
    else if (this.data.url) {
      const rootnode = document.createElement("div");
      const id = this.config.qnid;
      rootnode.classList.add("instant-pdf-tool");
      if (this._root) this._root.unmount();
      this._root = createRoot(rootnode);
      this._root.render(
        <FileUpload url={`library/content/${id}/${this.data.url.split("/").pop()}`} />
      );
      this.wrapper.appendChild(rootnode);
    }


    // const fileInput = document.createElement("input");
    // fileInput.type = "file";
    // fileInput.title = "Click to upload PDF";
    // fileInput.addEventListener("change", () =>
    //   this.handleImageSelection(fileInput.files[0])
    // );
    // this.wrapper.appendChild(fileInput);

    return this.wrapper;
  }

  handleImageSelection(file) {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const pdfUrl = event.target.result;
      this.data.file = file;
      this.data.url = "library/content/" + file.name;

      if (this.blockId) {
        this.api.blocks.update(this.blockId, { url: this.data.url, file: this.data.file });
      }

      const url = URL.createObjectURL(file);
      this.displayPdf(pdfUrl, url);
    };
    reader.readAsDataURL(file);
  }

  displayPdf(pdfUrl, url) {
    const pdfElement = document.createElement("iframe");
    pdfElement.src = url;
    pdfElement.width = "80%";
    pdfElement.height = "400px";
    pdfElement.classList.add("uploaded-pdf");
    this.wrapper.innerHTML = "";
    this.wrapper.appendChild(pdfElement);
  }

  save() {
    return {
      url: this.data.url,
      file: this.data.file,
    };
  }

  destroy() {
    if (this._root) {
      this._root.unmount();
      this._root = null;
    }
  }
}